<template>
    <div id="ldjgDetail">
        <div class="ldjgDetailWrap">
            <div class="bannerBox">
                <img src="../assets/test6.png">
                <div class="bannerAbsolute">
                    <p class="label_text">景观 售楼中心展示区 中国 绿地集团 墨刻景观 繁玺视觉</p>
                    <p class="china_text">绿地长沙麓湖郡体验区 / 墨刻景观</p>
                    <p class="en_text">Greenland Changsha Luhu County Experience Zone / Ink carved landscape</p>
                </div>
            </div>
            <div class="big1290">
                <div class="contentBox">
                    <div class="leftBox"></div>
                    <div class="rightBox">
                        <div class="topStyle">
                            <p class="title_text">最新案例</p>
                            <div class="lineBox">
                                <div class="lineStyle"></div>
                            </div>
                        </div>
                        <div class="contentInfo" v-for="(item,index) in 6" :key="index" :style="{marginTop:index==0?'21px':'40px'}">
                            <div class="imgBox">
                                <img class="hover-anm-e" src="../assets/test5.png">
                            </div>
                            <div class="intro_style">空灵体验，首尔艺术咖啡馆 / ATMOROUND</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="MldjgDetailWrap">
            <div class="bannerBox">
                <img src="../assets/test6.png">
                <div class="bannerAbsolute">
                    <p class="label_text">景观 售楼中心展示区 中国 绿地集团 墨刻景观 繁玺视觉</p>
                    <p class="china_text">绿地长沙麓湖郡体验区 / 墨刻景观</p>
                    <p class="en_text">Greenland Changsha Luhu County Experience Zone / Ink carved landscape</p>
                </div>
            </div>
            <div class="contentBox">
                <div class="leftBox"></div>
                <div class="rightBox">
                    <div class="topStyle">
                        <p class="title_text">最新案例</p>
                        <div class="lineBox">
                            <div class="lineStyle"></div>
                        </div>
                    </div>
                    <div class="contentInfo" v-for="(item,index) in 6" :key="index">
                        <div class="lineBox"></div>
                        <div class="imgBox">
                            <img class="hover-anm-e" src="../assets/test5.png">
                        </div>
                        <div class="name_style">广州中海学仕里洛嘉儿童乐园 / 奥雅设计 L&A</div>
                        <div class="intro_style">本案以“龙游曲江”为主题，打造现代极简风格空间，以四大亮点营造一处现代“雅集”</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "ldjgDetail",
    data() {
      return {}
    },
    created() {
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
    #ldjgDetail{
        .ldjgDetailWrap{
            .bannerBox{
                position: relative;
                width: 100%;
                min-width: 1290px;
                height: 680px;
                img{
                    width: 100%;
                    height: 100%;
                }
                .bannerAbsolute{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    padding: 0 0 20px 360px;
                    box-sizing: border-box;
                    color: white;
                    .label_text{
                        line-height: 18px;
                        font-size: 18px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    .china_text{
                        line-height: 66px;
                        margin-top: 10px;
                        font-size: 62px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    .en_text{
                        line-height: 25px;
                        font-size: 22px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
            }
            .contentBox{
                display: flex;
                justify-content: space-between;
                width: 1200px;
                margin: 80px auto;
                .leftBox{
                    width: 852px;
                    height: 2000px;
                    /*background-color: #2c3e50;*/
                }
                .rightBox{
                    width: 268px;
                    height: 2000px;
                    /*background-color: #2c3e50;*/
                    .topStyle{
                        .title_text{
                            line-height: 26px;
                            font-size: 26px;
                            color: #1A1A1A;
                        }
                        .lineBox{
                            position: relative;
                            width: 100%;
                            margin-top: 20px;
                            border-bottom: 1px solid #091905;
                            .lineStyle{
                                position: absolute;
                                bottom: 0;
                                left: 0;
                                width: 40px;
                                height: 4px;
                                background-color: #2D8575;
                            }
                        }
                    }
                    .contentInfo{
                        .imgBox{
                            width: 100%;
                            height: 164px;
                            overflow: hidden;
                        }
                        .intro_style{
                            width: 100%;
                            line-height: 31px;
                            margin-top: 10px;
                            font-size: 18px;
                            color: #091905;
                            overflow : hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
        }
        .MldjgDetailWrap{
            display: none;
            opacity: 0;
            width: 100%;
            margin: 0 auto;
            transition: .1s all linear;
            .bannerBox{
                position: relative;
                width: 100%;
                height: 3.5rem;
                img{
                    width: 100%;
                    height: 100%;
                }
                .bannerAbsolute{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    padding: 0 0 0.18rem 0.34rem;
                    box-sizing: border-box;
                    color: white;
                    .label_text{
                        line-height: 0.24rem;
                        font-size: 0.24rem;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    .china_text{
                        line-height: 0.44rem;
                        margin-top: 0.16rem;
                        font-size: 0.4rem;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    .en_text{
                        line-height: 0.22rem;
                        margin-top: 0.16rem;
                        font-size: 0.2rem;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
            }
            .contentBox{
                width: 100%;
                padding: 0 0.34rem;
                box-sizing: border-box;
                margin: 0.68rem auto;
                .leftBox{
                    width: 100%;
                    height: 20rem;
                    /*background-color: #2c3e50;*/
                }
                .rightBox{
                    width: 100%;
                    /*height: 10rem;*/
                    margin-top: 0.68rem;
                    /*background-color: #2c3e50;*/
                    .topStyle{
                        width: 100%;
                        .title_text{
                            line-height: 0.4rem;
                            font-size: 0.4rem;
                            color: #1A1A1A;
                        }
                        .lineBox{
                            position: relative;
                            width: 100%;
                            margin-top: 0.24rem;
                            border-bottom: 0.02rem solid #091905;
                            .lineStyle{
                                position: absolute;
                                bottom: 0;
                                left: 0;
                                width: 0.8rem;
                                height: 0.08rem;
                                background-color: #2D8575;
                            }
                        }
                    }
                    .contentInfo{
                        margin-top: 0.7rem;
                        .lineBox{
                            width: 100%;
                            height: 0.02rem;
                            background-color: #091905;
                        }
                        .imgBox{
                            width: 100%;
                            height: 3.83rem;
                            margin-top: 0.34rem;
                            overflow: hidden;
                        }
                        .name_style{
                            width: 100%;
                            line-height: 0.34rem;
                            margin-top: 0.32rem;
                            font-size: 0.32rem;
                            color: #091905;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .intro_style{
                            line-height: 0.48rem;
                            margin-top: 0.16rem;
                            font-size: 0.29rem;
                            color: #999E97;
                            overflow : hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:1024px){
        #ldjgDetail {

        }
    }
    @media screen and (max-width: 750px) {
        #ldjgDetail {
            .ldjgDetailWrap {
                display: none;
                opacity: 0;
            }
            .MldjgDetailWrap {
                display: block;
                opacity: 1;
                width: 7.5rem;
                /*padding: 0 0.34rem;*/
                /*box-sizing: border-box;*/
                margin: 0 auto;
            }
        }
    }
</style>
